/** @format */

import React, { useEffect, useMemo, useState } from "react";
import OrdersContentColumn from "../../orders/content/OrdersContentColumn";
import SectionItem from "../section-item";
import OrdersSectionItemInfoColumn from "../section-item/components/OrdersSectionItemInfoColumn";
import OrdersDatePicker from "../../orders/date-picker-new";
import OrdersTransportTypeWrapper from "../../orders/transport-type-new/OrdersTransportTypeWrapper";
import OrdersLocationInfo from "../../orders/location-info";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import AddYourCity from "../../orders/add-your-city/AddYourCity";
import CustomInput from "../../custom/custom-input/CustomInput";
import CustomSelect from "../../custom/custom-select";
import CustomUploadFile from "../../custom/custom-upload/CustomUploadFile";
import OrdersSectionItemPayment from "../section-item/components/OrdersSectionItemPayment";
import OrdersMap from "../map/OrdersMap";
import OrdersSectionItemCreate from "../section-item/components/OrdersSectionItemCreate";
import CustomButton from "../../custom/custom-button/CustomButton";
import AddIntermediatePoint from "../section-item/components/AddIntermediatePoint";
import CopyIcon from "../../shared/icons/CopyIcon";
import OrdersSectionItemPaymentExpeditor from "../section-item/components/OrdersSectionItemPaymentExpeditor";
import AccessDeniedModal from "../../shared/SubscriptionModal/AccessDeniedModal";
import {t} from "i18next";

const ExpeditorOrdersCreateDesktopView = ({
  setCountryFrom,
  setCityFrom,
  countries,
  countryFrom,
  citiesFrom,
  cityFrom,
  countryTo,
  setCountryTo,
  setCityTo,
  citiesTo,
  cityTo,
  pickUpDate,
  pickUpStartTime,
  pickUpEndTime,
  minPickDate,
  setPickUpDate,
  setPickUpStartTime,
  setPickUpEndTime,
  deliveryDate,
  deliveryStartTime,
  deliveryEndTime,
  minDeliveryDate,
  setDeliveryDate,
  setDeliveryStartTime,
  setDeliveryEndTime,
  types,
  setType,
  setTemperatury,
  type,
  addressTo,
  setAddressTo,
  recipientUpdate,
  addressFrom,
  setAddressFrom,
  setRecipientUpdate,
  recipientName,
  setRecipientName,
  recipientPhone,
  setRecipientPhone,
  volume,
  setVolume,
  weight,
  setWeight,
  categories,
  category,
  setCategory,
  temperatures,
  temperature,
  loadingTypes,
  loadingType,
  setLoadingType,
  details,
  setDetails,
  insurance,
  queryInsurance,
  declaredPrice,
  calcInsurance,
  fileInvoice,
  setInvoiceFile,
  files,
  setFiles,
  distance,
  price,
  netPrice,
  algoPrice,
  insurancePrice,
  createLoading,
  copyCount,
  setCopyCount,
  createOrder,
  orderCalculation,
  onResetPrice,
  saveDraft,
  updatePrice,
  onPriceChange,
  setIsСallСities,
  isCalculatePrice,
  isLoadingMap,
  routeData,
  routeStartCity,
  // partners,
  // setPartner,
  // partner,
  isTender,
  // setIsTender,
  // tenderDateEnd,
  // tenderStartTime,
  // tenderEndTime,
  // setTenderDateEnd,
  // setTenderStartTime,
  // setTenderEndTime,
  // partnersForTender,
  // setPartnersForTender,
  setCoordinatesFrom,
  setCoordinatesTo,
  coordinatesFrom,
  coordinatesTo,
  addressIdFrom,
  addressIdTo,
  setAddressIdFrom,
  setAddressIdTo,
  points,
  setPoints,
  setSenderPhone,
  setRouteDistance,
  setRouteDuration,
  isCopy = false,
  isEdit = false,
  headTitle = "",
  isPublic,
  setIsPublic,
}) => {
  const { user } = useSelector((state) => state);
  const [isOpenAddFrom, setIsOpenAddFrom] = useState(false);
  const [isOpenAddTo, setIsOpenAddTo] = useState(false);
  const [isDisplayModal, changeDisplayModal] = useState(false);

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (user?.permissions?.includes("restricted_view")) {
      changeDisplayModal(true);
    }
  }, []);

  useEffect(() => {
    if (
      cityFrom &&
      countryFrom &&
      cityTo &&
      countryTo &&
      category &&
      type &&
      weight &&
      volume
    ) {
      orderCalculation();
    }
  }, [cityFrom, countryFrom, cityTo, countryTo, category, type, weight, volume]);

  const isValidateForm = useMemo(() => {
    let allow = true;
    if (algoPrice) {
      if (!pickUpDate || !pickUpStartTime || !pickUpEndTime || !countryFrom) {
        allow = false;
      } else if (!deliveryDate || !deliveryStartTime || !deliveryEndTime || !countryTo) {
        allow = false;
      } else if ((insurance && !declaredPrice) || !recipientName) {
        allow = false;
      }
    }
    if (!cityFrom || !cityTo || !weight || !volume || !type || !category || !price || price <= 0) {
      allow = false;
    }
    if (isPublic === null) {
      allow = false;
    }
    if (weight && (weight.toString().length > 8 || parseFloat(weight) < 0)) {
      allow = false;
    }
    if (volume && (volume.toString().length > 8 || parseFloat(volume) < 0)) {
      allow = false;
    }
    if (points.some(point => 
      !point.country || 
      !point.city || 
      !point.address || 
      point.shippingDate === null || 
      !point.shippingDate || 
      point.shippingHourFrom === 0 || 
      point.shippingHourTo === 0 || 
      !point.shippingHourFrom || 
      !point.shippingHourTo || 
      !point.latLng || 
      !point.recipientName || 
      !point.recipientPhoneNumber
    )) {
      allow = false;
    }

    return allow;
  }, [
    pickUpDate,
    pickUpStartTime,
    pickUpEndTime,
    cityFrom,
    countryFrom,
    algoPrice,
    deliveryDate,
    deliveryStartTime,
    deliveryEndTime,
    cityTo,
    countryTo,
    category,
    type,
    weight,
    volume,
    insurance,
    declaredPrice,
    recipientName,
    price,
    points,
    isPublic
  ]);

  const submitFormData = () => {
    const newErrors = {};
    setErrors(null);
    if (!isValidateForm) {
      if (
        !pickUpDate ||
        !pickUpStartTime ||
        !pickUpEndTime ||
        !deliveryDate ||
        !deliveryStartTime ||
        !deliveryEndTime
      ) {
        const fillDataError = t('ordersCreate.validation.fillData');
        !pickUpDate && (newErrors.pickUpDate = fillDataError);
        !pickUpStartTime && (newErrors.pickUpStartTime = fillDataError);
        !pickUpEndTime && (newErrors.pickUpEndTime = fillDataError);
        !deliveryDate && (newErrors.deliveryDate = fillDataError);
        !deliveryStartTime && (newErrors.deliveryStartTime = fillDataError);
        !deliveryEndTime && (newErrors.deliveryEndTime = fillDataError);
        toast.error(t('ordersCreate.validation.fillTimeError'));
      }
      // if (!details) {
      //   toast.error('Необходимо заполнить поле "Описание груза"')
      // }
      const fillDataError = t('ordersCreate.validation.fillData');
      if (!addressFrom) {
        !addressFrom && (newErrors.addressFrom = fillDataError);
        toast.error(t('ordersCreate.validation.selectSenderError'));
      }
      if (!recipientName) {
        !recipientName && (newErrors.recipientName = fillDataError);
        toast.error(t('ordersCreate.validation.selectRecipientError'));
      }
      if (!copyCount || +copyCount < 1) {
        toast.error(t('ordersCreate.validation.copyCountZeroError'));
      }
      if (insurance && !declaredPrice) {
        toast.error(t('ordersCreate.validation.declaredPriceZeroError'));
      }

      if (!cityFrom || !countryFrom || !cityTo || !countryTo) {
        toast.error(t('ordersCreate.validation.fillCountryCityError'));
        !cityFrom && (newErrors.cityFrom = fillDataError);
        !countryFrom && (newErrors.countryFrom = fillDataError);
        !cityTo && (newErrors.cityTo = fillDataError);
        !countryTo && (newErrors.countryTo = fillDataError);
      }
      if (!category) {
        toast.error(t('ordersCreate.validation.selectCategoryError'));
        !category && (newErrors.category = fillDataError);
      }
      if (!type) {
        toast.error(t('ordersCreate.validation.selectTransportTypeError'));
        !type && (newErrors.type = fillDataError);
      }
      if (!weight || !volume) {
        toast.error(t('ordersCreate.validation.fillWeightVolumeError'));
        !weight && (newErrors.weight = fillDataError);
        !volume && (newErrors.volume = fillDataError);
      }
      if (weight && (weight.toString().length > 8 || parseFloat(weight) < 0)) {
        newErrors.weight = t('ordersCreate.validation.checkWeightError');
        toast.error(t('ordersCreate.validation.weightPositiveLengthError'));
      }
      if (volume && (volume.toString().length > 8 || parseFloat(volume) < 0)) {
        newErrors.volume = t('ordersCreate.validation.checkVolumeError');
        toast.error(t('ordersCreate.validation.volumePositiveLengthError'));
      }
      if (!price || price <= 0) {
        toast.error(t('ordersCreate.validation.specifyPriceError'));
        newErrors.price = t('ordersCreate.validation.specifyPriceError');
      }
      if (isPublic === null) {
        toast.error( t('ordersCreate.validation.specifyExecutorError'));
        newErrors.isPublic = t('ordersCreate.validation.specifyExecutorError');
      }
      if (points.length > 0) {
        const pointsErrors = {};
        points.forEach((point, index) => {
          const pointErrors = {};
          if (!point.country) {
            pointErrors.country = t('ordersCreate.validation.points.fillCountry');
          }
          if (!point.city) {
            pointErrors.city = t('ordersCreate.validation.points.fillCity');
          }
          if (!point.address) {
            pointErrors.address = t('ordersCreate.validation.points.fillAddress');
          }
          if (point.shippingDate === null || !point.shippingDate) {
            pointErrors.shippingDate = t('ordersCreate.validation.points.fillDeliveryDate');
          }
          if (point.shippingHourFrom === 0 || !point.shippingHourFrom) {
            pointErrors.shippingHourFrom = t('ordersCreate.validation.points.fillStartTime');
          }
          if (point.shippingHourTo === 0 || !point.shippingHourTo) {
            pointErrors.shippingHourTo = t('ordersCreate.validation.points.fillEndTime');
          }
          if (!point.latLng) {
            pointErrors.latLng = t('ordersCreate.validation.points.fillCoordinates');
          }
          if (!point.recipientName) {
            pointErrors.recipientName = t('ordersCreate.validation.points.fillRecipientName');
          }
          if (!point.recipientPhoneNumber) {
            pointErrors.recipientPhoneNumber = t('ordersCreate.validation.points.fillRecipientPhone');
          }

          if (Object.keys(pointErrors).length > 0) {
            pointsErrors[`points_${index + 2}`] = pointErrors;
            toast.error(t('ordersCreate.validation.points.incompleteError', { index: index + 2 }));
          }
        });
        if (Object.keys(pointsErrors).length > 0) {
          newErrors.points = pointsErrors;
        }
      }

      setErrors(newErrors);

      return;
    }

    if (isTender && !price) {
      onPriceChange(0);
      createOrder();
    } else if (price && algoPrice) {
      createOrder();
    } else if (price) {
      createOrder();
    }
  };

  return (
    <div style={{ position: "relative" }}>
      {isDisplayModal && <AccessDeniedModal onClose={() => changeDisplayModal(false)} />}

      {/* Info */}
      <OrdersContentColumn position>
        {(isCopy || isEdit) && (
          <SectionItem
            column={2}
            title={headTitle}
            isShadow
            isCopy
            prefixStart={<CopyIcon fill="#6D7885" />}
            isCunter={false}
          ></SectionItem>
        )}

        <SectionItem column={2} title={t("common.tableHead.from")} counter={1} isShadow>
          <OrdersSectionItemInfoColumn contentGridColumn={"1fr 1fr"}>
            <OrdersSectionItemInfoColumn title={t('ordersCreate.view.label.pickupCountry')}>
              <CustomSelect
                key={"countries-from"}
                labelText={t('ordersCreate.view.label.country')}
                placeholder={t('ordersCreate.view.label.pickupCountry')}
                errorText={errors?.countryFrom}
                options={countries}
                defaultValue={countryFrom}
                returnObject
                onSubmit={(item) => {
                  onResetPrice();
                  setCountryFrom(item);
                  setCityFrom(null);
                }}
              />
            </OrdersSectionItemInfoColumn>
            <OrdersSectionItemInfoColumn title={t('ordersCreate.view.label.pickupCity')}>
              <CustomSelect
                labelText={t('ordersCreate.view.label.city')}
                placeholder={t('ordersCreate.view.label.pickupCity')}
                errorText={errors?.cityFrom}
                options={citiesFrom}
                defaultValue={cityFrom}
                returnObject
                isDisabled={!countryFrom}
                onSubmit={(item) => {
                  onResetPrice();
                  setCityFrom(item);
                  setAddressFrom(null);
                  setAddressIdFrom(null);
                }}
                showNoOptionsMessage={true}
                onNoOptionsClick={() => {
                  setIsOpenAddFrom(true);
                }}
              />
              {isOpenAddFrom && (
                <AddYourCity
                  setCountry={setCountryFrom}
                  setCity={setCityFrom}
                  countries={countries}
                  country={countryFrom}
                  setIsСallСities={setIsСallСities}
                  setAddedCityId={setCityFrom}
                  isOpenAdd={isOpenAddFrom}
                  setIsOpenAdd={setIsOpenAddFrom}
                />
              )}
            </OrdersSectionItemInfoColumn>
          </OrdersSectionItemInfoColumn>

          {/* <OrdersSectionItemInfoColumn>
            <CustomInput
              labelText="Укажите адрес погрузки"
              placeholder="Введите адрес"
              // errorText={errors?.countryFrom}
              inputType="text"
              isBgGray={true}
              defaultValue={""}
            />
            {!isCommentVisibleFrom ? (
              <CustomButton
                prefixStart={<PlusIcon fill="#2857FC" />}
                isUnderline
                isBlueText
                text="Добавить комментарий к адресу"
                onClick={toggleCommentVisibilityFrom}
              />
            ) : null}
          </OrdersSectionItemInfoColumn> */}

          {/* {isCommentVisibleFrom && (
            <OrdersSectionItemInfoColumn>
              <CustomInput
                placeholder="Для уточнения адреса"
                labelText="Комментарий к адресу (необъязательно)"
                inputType="text"
                isBgGray={true}
                defaultValue={""}
                // errorText={errors?.}
              />
              <CustomButton
                prefixStart={<ExitIcon color="#6D7885" width="20px" height="20px" />}
                isUnderline
                isBlueText
                text="Скрыть комментарий"
                isGrayText
                onClick={toggleCommentVisibilityFrom}
              />
            </OrdersSectionItemInfoColumn>
          )} */}

          <OrdersSectionItemInfoColumn contentGridColumn={"1fr 1.3fr"}>
            <OrdersDatePicker
              date={pickUpDate}
              timeStart={pickUpStartTime}
              timeEnd={pickUpEndTime}
              minDate={minPickDate}
              isSender
              isEditable
              setDate={setPickUpDate}
              setTimeStart={setPickUpStartTime}
              setTimeEnd={setPickUpEndTime}
              // detect={saveDraft}
              labelText={t('ordersCreate.view.label.pickupDate')}
              labelTimeStart={t('ordersCreate.view.label.time')}
              labelTimeEnd={t('ordersCreate.view.label.timeUntil')}
              placeholderText={t('ordersCreate.view.placeholder.enterDate')}
              errorDate={errors?.pickUpDate}
              errorTimeStart={errors?.pickUpStartTime}
              errortimeEnd={errors?.pickUpEndTime}
            />
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn>
            <OrdersLocationInfo
              labelText={t('ordersCreate.view.label.sender')}
              errorText={errors?.addressFrom}
              isSender
              isEditable
              forceOpenDropdown={!!addressTo}
              forceOpenDropdownCount={recipientUpdate}
              companyName={user?.companyName}
              countries={countries}
              countrySelected={countryFrom}
              citySelected={cityFrom}
              address={addressFrom}
              onCoordinates={setCoordinatesFrom}
              onRecipientPhone={setSenderPhone}
              onAddressId={setAddressIdFrom}
              onChangeAddress={(item) => {
                setAddressFrom(item);
                setRecipientUpdate((prev) => prev + 1);
              }}
              onChangeCountry={(item) => {
                setCountryFrom(item);
                setCityFrom(null);
                // saveDraft();
              }}
              onChangeCity={(city) => {
                setCityFrom(city);
                // saveDraft();
              }}
              // detect={saveDraft}
            />

            {/* <CustomInput
              labelText="Номер телефона"
              placeholder="+7 (777) 777-77-77"
              inputType="text"
              isBgGray={true}
              defaultValue={""}
              isPhone
            /> */}
          </OrdersSectionItemInfoColumn>
        </SectionItem>

        {/* <SectionItem column={1} counter={1} isShadow isPSmall isMrAuto>
          <CustomButton 
            text="Добавить промежуточную точку"
            prefixStart={<PlusIcon fill="#2857FC" />}
            isUnderline
            isBlueText
            // onClick={}
          />
        </SectionItem> */}

        <AddIntermediatePoint
          points={points}
          setPoints={setPoints}
          countries={countries}
          cities={citiesTo}
          setIsOpenAddTo={setIsOpenAddTo}
          errors={errors?.points}
          user={user}
          pickUpDate={pickUpDate}
        />

        <SectionItem column={2} title={t('ordersCreate.view.sectionTitle.to')} counter={2 + points.length} isShadow>
          <OrdersSectionItemInfoColumn contentGridColumn={"1fr 1fr"}>
            <OrdersSectionItemInfoColumn title={t('ordersCreate.view.label.deliveryCountry')}>
              <CustomSelect
                labelText={t('ordersCreate.view.label.country')}
                placeholder={t('ordersCreate.view.label.deliveryCountry')}
                options={countries}
                errorText={errors?.countryTo}
                defaultValue={countryTo}
                returnObject
                onSubmit={(item) => {
                  onResetPrice();
                  setCountryTo(item);
                  setCityTo(null);
                  // saveDraft();
                }}
              />
            </OrdersSectionItemInfoColumn>
            <OrdersSectionItemInfoColumn title={t('ordersCreate.view.label.deliveryCity')}>
              <CustomSelect
                labelText={t('ordersCreate.view.label.city')}
                placeholder={t('ordersCreate.view.label.deliveryCity')}
                errorText={errors?.cityTo}
                options={citiesTo}
                defaultValue={cityTo}
                returnObject
                isDisabled={!countryTo}
                onSubmit={(item) => {
                  onResetPrice();
                  setCityTo(item);
                  setAddressTo(null);
                  setCoordinatesTo(null);
                  // saveDraft();
                }}
                showNoOptionsMessage={true}
                onNoOptionsClick={() => {
                  setIsOpenAddTo(true);
                }}
              />
              {isOpenAddTo && (
                <AddYourCity
                  setCountry={setCountryTo}
                  setCity={setCityTo}
                  country={countryTo}
                  countries={countries}
                  setIsСallСities={setIsСallСities}
                  setAddedCityId={setCityTo}
                  isOpenAdd={isOpenAddTo}
                  setIsOpenAdd={setIsOpenAddTo}
                />
              )}
            </OrdersSectionItemInfoColumn>
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn contentGridColumn={"1fr 1.3fr"}>
            <OrdersDatePicker
              date={deliveryDate}
              timeStart={deliveryStartTime}
              timeEnd={deliveryEndTime}
              minDate={points.length > 0 ? (points[points.length - 1]?.shippingDate || pickUpDate) : pickUpDate}
              isEditable
              setDate={setDeliveryDate}
              setTimeStart={setDeliveryStartTime}
              setTimeEnd={setDeliveryEndTime}
              // detect={saveDraft}
              labelText={t('ordersCreate.view.label.deliveryDate')}
              labelTimeStart={t('ordersCreate.view.label.time')}
              labelTimeEnd={t('ordersCreate.view.label.timeUntil')}
              placeholderText={t('ordersCreate.view.placeholder.enterDate')}
              errorDate={errors?.deliveryDate}
              errorTimeStart={errors?.deliveryStartTime}
              errortimeEnd={errors?.deliveryEndTime}
            />
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn>
            <OrdersLocationInfo
              labelText={t('ordersCreate.view.label.recipient')}
              errorText={errors?.recipientName}
              isEditable
              forceOpenDropdown={!!addressFrom}
              forceOpenDropdownCount={recipientUpdate}
              countries={countries}
              address={addressTo}
              countrySelected={countryTo}
              citySelected={cityTo}
              companyName={recipientName}
              phoneNumber={recipientPhone}
              onChangeAddress={(item) => {
                setAddressTo(item);
                setRecipientUpdate((prev) => prev + 1);
              }}
              onRecipientPhone={setRecipientPhone}
              onCoordinates={setCoordinatesTo}
              onAddressId={setAddressIdTo}
              onChangeResipient={setRecipientName}
              onChangeCountry={(item) => {
                setCountryTo(item);
                setCityTo(null);
                // saveDraft();
              }}
              onChangeCity={(city) => {
                setCityTo(city);
                // saveDraft();
              }}
              // detect={saveDraft}
            />

            {/* <CustomInput
              labelText="Номер телефона"
              placeholder="+7 (777) 777-77-77"
              inputType="text"
              isBgGray={true}
              defaultValue={""}
              isPhone
            /> */}
          </OrdersSectionItemInfoColumn>
        </SectionItem>

        <SectionItem
            column={2}
            title={t('ordersCreate.view.sectionTitle.orderDetails')}
            counter={3 + points.length}
            isShadow
        >
          <OrdersSectionItemInfoColumn title={t('ordersCreate.view.label.transportType')} isFullWidth>
            <OrdersTransportTypeWrapper
                types={types}
                onClick={(item) => {
                  onResetPrice();
                  setType(item);
                  if (item?.value === "awning") {
                    setTemperatury(null);
                  }
                  // saveDraft();
                }}
                defaultValue={type}
            />
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn contentGridColumn={"1fr 1fr"}>
            <CustomSelect
                labelText={t('ordersCreate.view.label.cargoCategory')}
                placeholder={t('ordersCreate.view.placeholder.selectCategory')}
                errorText={errors?.category}
                options={categories}
                defaultValue={category}
                onSubmit={(item) => {
                  onResetPrice();
                  setCategory(item);
                  // saveDraft();
                }}
                returnObject
            />
            <OrdersSectionItemInfoColumn contentGridColumn={"1fr 1fr"}>
              <CustomInput
                  labelText={t('ordersCreate.view.label.cargoVolume')}
                  // placeholder="86"
                  isBgGray={true}
                  errorText={errors?.volume}
                  prefixEnd={t("orderInfo.volume")}
                  inputType="number"
                  value={volume}
                  onChangeValue={(item) => {
                    onResetPrice();
                    setVolume(item);
                    // saveDraft();
                  }}
              />
              <CustomInput
                  labelText={t('ordersCreate.view.label.cargoWeight')}
                  // placeholder="20"
                  isBgGray={true}
                  errorText={errors?.weight}
                  prefixEnd={<span>{t('ordersCreate.view.unit.tons')}</span>}
                  inputType="number"
                  value={weight}
                  onChangeValue={(item) => {
                    onResetPrice();
                    setWeight(item);
                    // saveDraft();
                  }}
              />
            </OrdersSectionItemInfoColumn>
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn contentGridColumn={"1fr 1fr"}>
            <CustomSelect
                labelText={t('ordersCreate.view.label.temperatureMode')}
                placeholder={t('ordersCreate.view.placeholder.selectMode')}
                errorText={errors?.temperature}
                options={temperatures}
                defaultValue={temperature}
                onSubmit={(item) => {
                  setTemperatury(item);
                  // saveDraft();
                }}
                returnObject
                isDisabled={type?.value === "awning"}
            />
            <CustomSelect
                labelText={t('ordersCreate.view.label.loadingType')}
                placeholder={t('ordersCreate.view.placeholder.selectLoadingType')}
                errorText={errors?.loadingType}
                options={loadingTypes}
                defaultValue={loadingType}
                onSubmit={(item) => {
                  setLoadingType(item);
                  // saveDraft();
                }}
                returnObject
            />
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn>
            <CustomUploadFile
                user={user}
                files={files}
                onUploadFiles={(files) => {
                  setFiles(files);
                  // saveDraft();
                }}
            />
          </OrdersSectionItemInfoColumn>
        </SectionItem>

        <SectionItem counter={4 + points.length} column={2} title={t('ordersCreate.view.sectionTitle.payment')} isShadow>
          <OrdersSectionItemPaymentExpeditor
            icon={"/icons/logoY.svg"}
            title={t('ordersCreate.view.label.recommendedPrice')}
            subtitle={""}
            buttonText={t('ordersCreate.view.button.createOrder')}
            isValidate={isValidateForm}
            price={price}
            algoPrice={algoPrice}
            priceDiscount={insurancePrice}
            displayInput
            buttonColor="brand"
            defaultCount={copyCount}
            changeInput={setCopyCount}
            updatePrice={updatePrice}
            onPriceChange={onPriceChange}
            isCalculatePrice={isCalculatePrice}
            errorText={errors?.price}
            withInsurance={insurance}
            queryInsurance={queryInsurance}
            declaredPrice={declaredPrice}
            calcInsurance={calcInsurance}
            fileInvoice={fileInvoice}
            setInvoiceFile={setInvoiceFile}
            // saveDraft={saveDraft}
            isPublic={isPublic}
            setIsPublic={setIsPublic}
            errorsIsPublic={errors?.isPublic}
            companyName={user?.companyName}
            user={user}
          />
        </SectionItem>

        <SectionItem isShadow isPSmall>
          <OrdersSectionItemCreate
            onSubmit={submitFormData}
            onSubmitDraft={saveDraft}
            isLoading={createLoading}
          />
        </SectionItem>
      </OrdersContentColumn>

      <OrdersMap
        isLoadingMap={isLoadingMap}
        routeData={routeData}
        routeStartCity={routeStartCity}
        cityFrom={cityFrom}
        cityTo={cityTo}
        addressIdFrom={addressIdFrom}
        addressIdTo={addressIdTo}
        coordinatesFrom={coordinatesFrom}
        coordinatesTo={coordinatesTo}
        points={points}
        setRouteDistance={setRouteDistance}
        setRouteDuration={setRouteDuration}
      />
    </div>
  );
};

export default ExpeditorOrdersCreateDesktopView;
